export const XIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width={9}
      height={9}
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.8 0.8L8.2 8.2M8.2 0.8L0.8 8.2"
        // d="M0.9 0.9L8.1 8.1M8.1 0.9L0.9 8.1"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
